import { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '@/components/layout/Layout';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CGVPage = () => {
  const [pageData, setPageData] = useState({ title: 'Conditions Générales de Vente', content: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(`${API}/legal-pages/cgv`);
        if (res.data.title && res.data.content) {
          setPageData(res.data);
        }
      } catch (error) {
        console.error('Error fetching legal page:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-gradient-to-br from-emerald-600 via-emerald-700 to-teal-800 py-16 pt-28 lg:pt-36">
        <div className="container-custom relative z-10">
          <h1 className="font-heading font-bold text-3xl md:text-4xl text-white">
            {pageData.title}
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white" data-testid="cgv-content">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto prose prose-stone prose-lg">
            {loading ? (
              <div className="flex justify-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-2 border-emerald-600 border-t-transparent"></div>
              </div>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: pageData.content }} />
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CGVPage;
